import { render } from "./ProductImagePlaceholders.vue?vue&type=template&id=64668db5&scoped=true"
import script from "./ProductImagePlaceholders.vue?vue&type=script&lang=js"
export * from "./ProductImagePlaceholders.vue?vue&type=script&lang=js"

import "./ProductImagePlaceholders.vue?vue&type=style&index=0&id=64668db5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64668db5"]])

export default __exports__